// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import { productionGates } from "../config/production-gates.js";
import { useI18n } from "../i18n/I18nContext.jsx";
import { getVerifiedContact } from "../content/repository.js";

export function SiteFooter() {
  const { t, locale } = useI18n();
  const email = getVerifiedContact("email")?.value;
  const phones = [
    getVerifiedContact("phone-engineering")?.value,
    getVerifiedContact("phone-primary")?.value,
    getVerifiedContact("phone-secondary")?.value,
  ].filter(Boolean);
  const sections = [
    ["/solutions", t.solutions],
    ["/equipment", t.equipment],
    ["/software/tracora", "Tracora"],
    ["/engineering-center", t.engineering],
    ["/service", t.service],
    [
      "/consumables-parts",
      locale === "uz"
        ? "Sarf materiallar va ehtiyot qismlar"
        : locale === "en"
          ? "Consumables and spare parts"
          : "Расходники и запчасти",
    ],
    ["/knowledge", t.knowledge],
    ["/about", t.about],
    ["/contacts", t.contacts],
    ["/privacy", t.privacy],
  ];
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <Link className="footer-brand-lockup" to="/" aria-label={`ANLEXX — ${t.home}`}>
          <span className="footer-logo-frame" aria-hidden="true"><img src="/images/anlexx-logo.jpg" alt="" /></span>
          <span className="footer-mark">ANLEXX<small>{t.tagline}</small></span>
        </Link>
        <nav aria-label={t.footerNav}>
          {sections
            .filter(
              ([href]) =>
                (href !== "/knowledge" || productionGates.knowledge) &&
                (href !== "/privacy" || productionGates.privacy),
            )
            .map(([href, label]) => (
              <Link key={href} to={href}>
                {label}
              </Link>
            ))}
        </nav>
        <div className="footer-status">
          <span>{t.since}</span>
          {phones.map((phone) => (
            <a href={`tel:${phone.replace(/[^+\d]/g, "")}`} key={phone}>
              {phone}
            </a>
          ))}
          {email && <a href={`mailto:${email}`}>{email}</a>}
          {!email && phones.length === 0 && (
            <small>{t.contactsPending}</small>
          )}
        </div>
        <div className="footer-legal">
          © 2026 ANLEXX
          <br />
          {t.country}
        </div>
      </div>
    </footer>
  );
}
